'use strict';
/**
 * Keeps track of all running queries.
 */

var _createForOfIteratorHelper = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var QueryManager = /*#__PURE__*/function () {
  /**
   * Creates a new QueryManager.
   */
  function QueryManager() {
    _classCallCheck(this, QueryManager);

    this.queries = new Set();
    this.running = false;
  }
  /**
   * Called when a query is started.
   *
   * @param {Query} query
   */


  _createClass(QueryManager, [{
    key: "queryStarted",
    value: function queryStarted(query) {
      this.queries.add(query);
    }
    /**
     * Called when a query completes.
     *
     * @param {Query} query
     */

  }, {
    key: "queryCompleted",
    value: function queryCompleted(query) {
      this.queries.delete(query);
    }
    /**
     * Starts the query manager.
     */

  }, {
    key: "start",
    value: function start() {
      this.running = true;
    }
    /**
     * Stops all queries.
     */

  }, {
    key: "stop",
    value: function stop() {
      this.running = false;

      var _iterator = _createForOfIteratorHelper(this.queries),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var query = _step.value;
          query.stop();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this.queries.clear();
    }
  }]);

  return QueryManager;
}();

module.exports = QueryManager;